import { createAction, createSlice } from '@reduxjs/toolkit';

import { initialStore } from '../initial-store';

export const getRequestLogs = createAction('requestLogs/GET_REQUEST_LOGS');

const requestLogsSlice = createSlice({
  initialState: initialStore.requestLogsPage,
  name: 'requestLogsPage',
  reducers: {
    setLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    // `page` comes back from the saga alongside the response: the first page replaces
    // the list, every following one is appended (infinite scroll).
    setRequestLogs: (state, { payload }) => {
      const { count, page, result } = payload;

      state.data = page > 1 ? [...state.data, ...result] : result;
      state.count = count;
      state.isLoading = false;
    }
  }
});

export const { setLoading, setRequestLogs } = requestLogsSlice.actions;

export const { reducer } = requestLogsSlice;
